import general from './kz_general'
import header from './kz_header'
import sidebar from './kz_sidebar'
import calendar from './kz_calendar'
import warehouses from './kz_warehouses'
import patients from "./kz_patients"
import settings from "./kz_settings"
import services from "./kz_services"
import staff from "./kz_staff"
import accounting from "./kz_accounting"
import reports from "./kz_reports"
import templates from "./kz_templates"
import cashdesk from "./kz_cashdesk"
import planning from "./kz_planning"
import crm from "./kz_crm"
import egisz from "./kz_egisz"
import marketing from "./kz_marketing"
import insurance from "./kz_insurance"
import tags from "./kz_tags"
import referral from "./kz_referral"
import laboratories from "./kz_laboratories"
import documents from "./kz_documents"
import profile from "./kz_profile"
import telegram from "./kz_telegram"
import market from "./kz_market"
import legal from "./kz_legal"
import nontranslated from "./kz_nontranslated"

export default {
    ...general,
    ...header,
    ...sidebar,
    ...calendar,
    ...warehouses,
    ...patients,
    ...services,
    ...staff,
    ...accounting,
    ...reports,
    ...templates,
    ...cashdesk,
    ...planning,
    ...settings,
    ...crm,
    ...egisz,
    ...marketing,
    ...insurance,
    ...tags,
    ...referral,
    ...laboratories,
    ...documents,
    ...profile,
    ...telegram,
    ...market,
    ...legal,
    ...nontranslated
}
